import {GetProductBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {Button, FONT_SIZES, FONT_WEIGHTS} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const DiscoverMoreView: React.FC<
  GetProductBulkResponse['linksSection'] & {className?: string}
> = ({backLinkLabel, backLinkTarget, className}) => {
  const {t} = useTranslation();

  return (
    <StyledButton
      data-testid="DiscoverMore"
      href={backLinkTarget?.url}
      className={className}
      size="fit-width"
    >
      {t('More {category}', {category: backLinkLabel})}
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  &&& {
    font-size: ${FONT_SIZES.px12};
    font-weight: ${FONT_WEIGHTS.mediumHeavy};
    line-height: ${FONT_SIZES.px18};
  }
`;
